import { Component, inject, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { environment } from '../../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MilaIconSvgComponent } from '../../../../../assets/svg/mila-icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-need-help-deciding',
  imports: [CommonModule, TranslateModule, MatCardModule, MatIconModule, MatButtonModule, MilaIconSvgComponent],
  templateUrl: './need-help-deciding.component.html',
  styleUrl: './need-help-deciding.component.css'
})
export class NeedHelpDecidingComponent {

  @Input() locale: string | null = null;

  private sanitizer = inject(DomSanitizer);

  language: string = '';
  isChatBotOpen = false;
  gyantChatLaunchURL = environment.mobile_open_chat_bot_deep_link_base_url
  trustedGyantChatLaunchURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.gyantChatLaunchURL);

  constructor(private translate: TranslateService) {
    this.translate.use(this.locale || 'en-US'); // Default to 'en-US' if no locale is provided
  }

  async openChatBot() {
    var eptID = sessionStorage.getItem("eptID") ?? null;

    // Define the Gyant create account endpoint URL
    const gyantCrateAccountURL = environment.gyantt_base_url + "api/create-account";


    if (eptID == null || eptID.length === 0) {
      if (this.locale?.toLowerCase() == "es-us") {
        this.gyantChatLaunchURL += "&language=spanish";
    }
      window.location.href = this.gyantChatLaunchURL;
    }

    if (this.locale?.toLowerCase() == 'es-us') {
      this.language = 'es_US'; 
    }
    else {
      this.language = 'en_US';
    }

    // Prepare the request body
    const requestBody = {
      client: 'mmc-mychart-fd',
      locale: this.language,
      version: '4.0',
      patientId: eptID,
      patientIdType: 'EXTERNAL',
      patientSource: 'epic',
    };

    // Make a POST request to Gyant's create account endpoint
    // if the patient ID is not available, we launch an unauthenticated chat
    await fetch(gyantCrateAccountURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "origin": "https://mychart-np.et0498.epichosted.com"
      },
      body: JSON.stringify(requestBody) // Convert the request body to JSON
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json(); // Parse the JSON response
    })
    .then(data => {
      console.log("Gyant response:", data);

      if (!data.sessionToken) {
        alert("Token is missing in the response.");
        return;
      }

      // Append the session token to the Gyant chat launch URL
      this.gyantChatLaunchURL += "&sessionToken=" + data.sessionToken;
      this.trustedGyantChatLaunchURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.gyantChatLaunchURL);
      
      if (!this.trustedGyantChatLaunchURL) {
        throw new Error("Failed to sanitize Gyant chat launch URL.");
      }

      window.location.href = this.gyantChatLaunchURL;
    })
    .catch(error => {
      console.error("Error making POST request to Gyant:", error);
    });

    // redirect to Gyant's chatbot URL, whether unauthenticated or authenticated
    this.isChatBotOpen = true;
  }

}
